{
    "title": "Choose an document to upload",
    "subtitle": "To validate your application we need to verify your identity. Please upload a copy of an document below.",
    "option": {
        "passport":"Passport",
        "driverslicense":"Driver's License",
        "nationalid":"National ID"
    },
    "validating": "We are validating your data, please wait..."
}